export class PoBox {
    constructor() {
        this.poBox = false;
        this.poBoxNr = null;
        this.poBoxZipCode = null;
        this.poBoxCity = null;
    }
}
